export default __webpack_public_path__ + "static/media/kerjoo-tracker-logo-dark.4313891e.png";